<div class="search-suggest-brands">
  <div class="d-flex justify-content-start headline">{{ 'suggest.brands.headline' | translate }}</div>
  <ul>
    @for (brand of brands() | slice : 0 : maxAutoSuggests(); track brand) {
    <li>
      <!--DIAS CUSTOMIZATION STARTS-->
      @if ((isFeatureEnabled$() | async) === false) {
      <a
        [routerLink]="['search', inputTerms$() | async]"
        [queryParams]="{ filters: 'ManufacturerName=' + brand.brandName }"
        [innerHTML]="brand.brandName | ishHighlight : (inputTerms$() | async)"
        (click)="handleInputFocus(brand.brandName)"
      ></a>

      } @if ((isFeatureEnabled$() | async) === true) {

      <a
        [routerLink]="['search', brand.brandName]"
        [queryParams]="{ filters: 'brand=' + brand.brandName }"
        [innerHTML]="brand.brandName | ishHighlight : (inputTerms$() | async)"
        (click)="handleInputFocus(brand.brandName)"
      ></a>

      }
      <!--DIAS CUSTOMIZATION ENDS-->
    </li>
    }
  </ul>
</div>
